export const MARK_NOTIFICATION_AS_READ_START = 'MARK_NOTIFICATION_AS_READ_START';
export const MARK_NOTIFICATION_AS_READ_SUCCESS = 'MARK_NOTIFICATION_AS_READ_SUCCESS';
export const MARK_NOTIFICATION_AS_READ_FAIL = 'MARK_NOTIFICATION_AS_READ_FAIL';

export const MARK_AS_REMIND_LATER_START = 'MARK_AS_REMIND_LATER_START';
export const MARK_AS_REMIND_LATER_SUCCESS = 'MARK_AS_REMIND_LATER_SUCCESS';
export const MARK_AS_REMIND_LATER_FAIL = 'MARK_AS_REMIND_LATER_FAIL';
